var map = {
	"./auth-background.webp": 1916,
	"./close-btn.webp": 1917,
	"./icon-caution.webp": 1918,
	"./icon-checked.webp": 1919,
	"./icon-contact-us.webp": 1920,
	"./icon-email.webp": 1921,
	"./icon-eye-close.webp": 1922,
	"./icon-eye-open.webp": 1923,
	"./icon-forget-phone.webp": 1924,
	"./icon-forget-whatsapp.webp": 1925,
	"./icon-google.webp": 1926,
	"./icon-login-email-2.webp": 1927,
	"./icon-login-email.webp": 1928,
	"./icon-password.webp": 1929,
	"./icon-robot-select.webp": 1930,
	"./icon-robot-unselect.webp": 1931,
	"./icon-telegram.webp": 1932,
	"./icon-user.webp": 1933,
	"./jackpot-cn.webp": 1934,
	"./jackpot-mobile-cn.webp": 1935,
	"./jackpot-mobile-ms.webp": 1936,
	"./jackpot-mobile.webp": 1937,
	"./jackpot-ms.webp": 1938,
	"./jackpot.webp": 1939,
	"./login-bg.webp": 1940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;